import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { FormattedMessage } from 'react-intl';

import { STRIPE_API_KEY } from '../../../../config';
import { useLocale } from '../../../../context/LocaleContext';
import { SelectedCarbonOffsetProjectT } from '../../../CarbonOffsetsPage/hooks/useCarbonOffsets';
import { SelectedSustainableActionsT } from '../../../SustainableActionsPage/hooks/useSustainableActions';
import { SectionTitleStyled } from '../../PaymentDetailsPage.styled';
import { PaymentFormWrapperStyled } from './PaymentCard.styled';
import PaymentForm from './PaymentForm';

export type PaymentCardPropsT = {
  isBreadcrumbClicked: number;
  carbonOffsets: SelectedCarbonOffsetProjectT[];
  sustainableActions: SelectedSustainableActionsT[];
};

const stripePromise = loadStripe(STRIPE_API_KEY);

const PaymentCard: React.FC<PaymentCardPropsT> = ({
  isBreadcrumbClicked,
  sustainableActions,
  carbonOffsets,
}) => {
  const { selectedLocale } = useLocale();

  return (
    <PaymentFormWrapperStyled>
      <SectionTitleStyled>
        <FormattedMessage id="breadcrumbs.paymentDetails" defaultMessage="Payment Details" />
      </SectionTitleStyled>

      <Elements
        stripe={stripePromise}
        options={{
          locale: selectedLocale,
        }}
      >
        <PaymentForm
          isBreadcrumbClicked={isBreadcrumbClicked}
          sustainableActions={sustainableActions}
          carbonOffsets={carbonOffsets}
        />
      </Elements>
    </PaymentFormWrapperStyled>
  );
};

export default PaymentCard;
